import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  IconButton,
  Box,
  Badge,
  MenuItem,
  MenuList,
  Paper,
  ClickAwayListener,
  Avatar,
  Button,
  Popper,
  Fade,
  Drawer,
  List,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  alpha,
  Typography,
  Divider,
  Tooltip,
  Chip,
} from "@mui/material";
import {
  Campaign,
  Message,
  Notifications,
  Logout,
  Home,
  Poll,
  Business,
  Person,
  SmartToy,
  AccessTime,
} from "@mui/icons-material";
import AuthContext from "../../../Context/Auth/AuthContext.js";
import MenuContext from "../../../Context/Menu/MenuContext.js";
import clienteAxios from "../../../config/axios.js";
import { NavLink, withRouter } from "react-router-dom";
import Perfil from "./Perfil";
import Encuestas from "./Encuestas";
import { useProvideSocket } from "../../../views/Chat/socket/useProvideSocket.js";
import DialogEmpresas from "./DialogEmpresas.js";

const TIPOS_NOTIFICACION1 = [
  "ACTIVIDAD",
  "CONSIGNA",
  "EVALUACIONES",
  "ENCUESTAS",
];

const timeAgo = (dateStr) => {
  if (!dateStr) return "";
  const now = new Date();
  const date = new Date(dateStr);
  const diffMs = now - date;
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return "Ahora";
  if (diffMin < 60) return `${diffMin}m`;
  const diffHours = Math.floor(diffMin / 60);
  if (diffHours < 24) return `${diffHours}h`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `${diffDays}d`;
  return date.toLocaleDateString();
};

const getTipoColor = (tipo) => {
  const map = {
    CONSIGNA: "info",
    ACTIVIDAD: "success",
    EVALUACIONES: "secondary",
    ENCUESTAS: "warning",
    PERMISO: "info",
    VACACION: "success",
    TURNO_EXTRA: "warning",
    MULTA: "error",
    MEJORA_CONTINUA: "primary",
    GESTION_DOCUMENTAL: "info",
    DOCUMENTOS_EXPIRADOS: "error",
  };
  return map[tipo] || "default";
};

const NotificactionsButtons = (props) => {
  const { usuario, socket, cerrarSesion } = useContext(AuthContext);
  const { rows } = useContext(MenuContext);
  const { onNotificacionesChange } = props;

  const categorias = useMemo(
    () => (rows || []).filter((item) => item.sidInfo.tipo === "categoria"),
    [rows],
  );

  const subCategorias = useMemo(() => {
    if (categorias.length === 0) return [];
    return (rows || [])
      .filter((item) => item.sidInfo.tipo === "subCategoria")
      .map((item) => ({
        ...item,
        padre:
          categorias.find(
            (padre) => padre.sidInfo.path === item.sidInfo.categoria,
          )?.sidId ?? 0,
      }));
  }, [rows, categorias]);

  const subsubCategorias = useMemo(() => {
    if (subCategorias.length === 0) return [];
    return (rows || [])
      .filter((item) => item.sidInfo.tipo === "subsubCategoria")
      .map((item) => ({
        ...item,
        padre:
          subCategorias.find(
            (padre) => padre.sidInfo.path === item.sidInfo.subcategoria,
          )?.sidId ?? 0,
      }));
  }, [rows, subCategorias]);

  const sub_sub_subCategorias = useMemo(() => {
    if (subsubCategorias.length === 0) return [];
    return (rows || [])
      .filter((item) => item.sidInfo.tipo === "sub_sub_subCategoria")
      .map((item) => ({
        ...item,
        padre:
          subsubCategorias.find(
            (padre) => padre.sidInfo.path === item.sidInfo.subsubCategoria,
          )?.sidId ?? 0,
      }));
  }, [rows, subsubCategorias]);

  const allRows = useMemo(
    () => [
      ...sub_sub_subCategorias,
      ...subsubCategorias,
      ...subCategorias,
      ...categorias,
    ],
    [categorias, subCategorias, subsubCategorias, sub_sub_subCategorias],
  );

  const buildFullPath = (item) => {
    const parts = [];
    let current = item;
    while (current) {
      parts.unshift(current.sidInfo.path);
      if (current.padre) {
        current = allRows.find((r) => r.sidId === current.padre);
      } else {
        current = null;
      }
    }
    return (item.sidInfo.layout || "/Seguridad") + parts.join("");
  };

  const getNotificacionLink = (notificacion) => {
    const componentName = notificacion.notInformacion?.component;
    if (!componentName) return notificacion.notInformacion?.urlweb || "";
    const menuItem = allRows.find((r) => r.sidInfo.component === componentName);
    if (!menuItem) return notificacion.notInformacion?.urlweb || "";
    const fullPath = buildFullPath(menuItem);
    const params = notificacion.notInformacion?.params;
    return params ? `${fullPath}?${params}` : fullPath;
  };
  const [openEncuestas, setopenEncuestas] = useState(false);
  const [openMenu, setOpenMenu] = React.useState(false);
  const [openEmpresasDialog, setopenEmpresasDialog] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu((previousOpen) => !previousOpen);
  };
  const canBeOpen = openMenu && Boolean(anchorEl);
  const id = canBeOpen ? "transition-popper" : undefined;

  const [openNotificacion2, setOpenNotificacion2] = React.useState(false);
  const [anchorElNotificacion2, setAnchorElNotificacion2] = React.useState(
    null,
  );
  const handleClickNotificacion2 = (event) => {
    setAnchorElNotificacion2(event.currentTarget);
    setOpenNotificacion2((previousOpen) => !previousOpen);
  };
  const canBeOpenNotificacion2 =
    openNotificacion2 && Boolean(anchorElNotificacion2);
  const idNotificacion2 = canBeOpenNotificacion2
    ? "transition-popperNotificacion2"
    : undefined;

  const [openPerfil, setopenPerfil] = useState(false);

  const handleEditar = (notificacion) => {
    socket.emit("client:actualizarData", {
      tabla: "notificacionleido",
      notId: notificacion.notId,
      rucempresa: usuario.rucempresa,
    });
    const link = getNotificacionLink(notificacion);
    if (link) {
      setOpenNotificacion2(false);
      props.history.push(link);
    }
  };

  const [notificacionesData, setnotificacionesData] = useState({
    notificacion1: [],
    notificacion2: [],
    estado: false,
  });
  const [itemEdit, setitemEdit] = useState(false);
  const [nuevoItem, setnuevoItem] = useState(false);

  useEffect(() => {
    const getData = async () => {
      const resNotificaciones = await clienteAxios.get(
        "/notificaciones/listado",
      );
      console.log({ resNotificaciones });

      if (
        resNotificaciones.data.data.notificacion1 ||
        resNotificaciones.data.data.notificacion2
      ) {
        setnotificacionesData({ estado: true, ...resNotificaciones.data.data });
      }
    };
    getData();
  }, [usuario.rucempresa]);

  useEffect(() => {
    socket.on("server:actualizadoExitoso", async (data) => {
      setitemEdit(data);
      return () => {
        socket.off("server:actualizadoExitoso");
      };
    });
    socket.on("server:nuevanotificacion", async (data) => {
      setnuevoItem(data);
      return () => {
        socket.off("server:nuevanotificacion");
      };
    });
  }, []);

  useEffect(() => {
    if (itemEdit) {
      if (TIPOS_NOTIFICACION1.includes(itemEdit.notTipo)) {
        const res = notificacionesData.notificacion1.map((n) =>
          n.notId === itemEdit.notId ? itemEdit : n,
        );
        setnotificacionesData({ ...notificacionesData, notificacion1: res });
      } else {
        const res = notificacionesData.notificacion2.map((n) =>
          n.notId === itemEdit.notId ? itemEdit : n,
        );
        setnotificacionesData({ ...notificacionesData, notificacion2: res });
      }
      setitemEdit(false);
    }
    if (nuevoItem) {
      if (TIPOS_NOTIFICACION1.includes(nuevoItem.notTipo)) {
        setnotificacionesData({
          ...notificacionesData,
          notificacion1: [nuevoItem, ...notificacionesData.notificacion1],
        });
      } else {
        setnotificacionesData({
          ...notificacionesData,
          notificacion2: [nuevoItem, ...notificacionesData.notificacion2],
        });
      }
      setnuevoItem(false);
    }
  }, [itemEdit, nuevoItem]);

  const [mensaje, setmensaje] = useState({});
  useEffect(() => {
    const getMensaje = async () => {
      try {
        const res = await clienteAxios.get(
          "/actualizaciones/mostrarMensaje/web",
        );
        setmensaje(res?.data || {});
      } catch (error) {
        console.log({ error });
      }
    };
    getMensaje();
  }, []);

  const [openDrawerChat, setopenDrawerChat] = useState(false);
  const onToogleDrawerChat = () => {
    setopenDrawerChat(!openDrawerChat);
  };
  const { socket: socketChat, online, traerGruposEffect } = useProvideSocket();
  const [grupos, setgrupos] = useState([]);
  const [totales, settotales] = useState(0);

  useEffect(() => {
    const handleListaChatsGrupos = (data) => {
      setgrupos(data);
    };
    const handleTotalesActualizados = (data) => {
      if (data) {
        setgrupos(data.refresh_groups);
        settotales(data.unread_messages);
      }
    };
    const handleSendMensaje = (data) => {
      socketChat?.emit("client:totales-actualizados", {
        rucempresa: usuario.rucempresa,
        id_user: usuario.id,
      });
    };
    socketChat?.on("server:lista-chats-grupos", handleListaChatsGrupos);
    socketChat?.on("server:totales-actualizados", handleTotalesActualizados);
    socketChat?.on("server:send-mensaje", handleSendMensaje);
    return () => {
      socketChat?.off("server:lista-chats-grupos", handleListaChatsGrupos);
      socketChat?.off("server:totales-actualizados", handleTotalesActualizados);
      socketChat?.off("server:send-mensaje", handleSendMensaje);
    };
  }, [socketChat, online]);

  const getData = async () => {
    const res = await clienteAxios.get("/messages/chatsNoLeidoYGruposChats/0");
    setgrupos(res.data.refresh_groups);
    settotales(res.data.unread_messages);
  };
  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    if (traerGruposEffect > 1) getData();
  }, [traerGruposEffect]);

  const iconBtnSx = {
    borderRadius: 2,
    p: 0.8,
    color: "text.secondary",
    "&:hover": {
      backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
      color: "primary.main",
    },
    transition: "all 0.2s",
  };

  const badgeSx = {
    "& .MuiBadge-badge": {
      fontSize: "0.65rem",
      minWidth: 16,
      height: 16,
      fontWeight: 700,
    },
  };

  const totalNoLeidas = [
    ...notificacionesData.notificacion1,
    ...notificacionesData.notificacion2,
  ].filter((n) => n.notVisto === "NO").length;

  useEffect(() => {
    if (onNotificacionesChange) onNotificacionesChange(totalNoLeidas);
  }, [totalNoLeidas]);

  const todasNotificaciones = [
    ...notificacionesData.notificacion1,
    ...notificacionesData.notificacion2,
  ]
    .sort((a, b) => b.notId - a.notId)
    .filter((n) => n.notVisto === "NO");

  const renderNotificacionItem = (item, onClick, linkTo) => {
    const unread = item.notVisto === "NO";
    const isSystem = item.notOrigen === "Sistema";
    const content = (
      <Box
        onClick={onClick}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 1.5,
          p: 1.5,
          position: "relative",
          backgroundColor: unread
            ? (theme) => alpha(theme.palette.primary.main, 0.06)
            : (theme) => alpha(theme.palette.action.hover, 0.3),
          borderBottom: (theme) =>
            `1px solid ${alpha(theme.palette.divider, 0.06)}`,
          cursor: unread ? "pointer" : "default",
          transition: "background-color 0.15s",
          "&:hover": {
            backgroundColor: (theme) =>
              unread
                ? alpha(theme.palette.primary.main, 0.1)
                : alpha(theme.palette.action.hover, 0.6),
          },
        }}
      >
        {unread && (
          <Box
            sx={{
              position: "absolute",
              left: 4,
              top: "50%",
              transform: "translateY(-50%)",
              width: 4,
              height: 4,
              borderRadius: "50%",
              backgroundColor: "primary.main",
            }}
          />
        )}
        {isSystem ? (
          <Avatar
            sx={{
              width: 36,
              height: 36,
              flexShrink: 0,
              bgcolor: (theme) => alpha(theme.palette.grey[500], 0.12),
              color: "grey.600",
            }}
          >
            <SmartToy sx={{ fontSize: "1.1rem" }} />
          </Avatar>
        ) : (
          <Avatar
            src={item.notFoto}
            sx={{ width: 36, height: 36, flexShrink: 0 }}
          />
        )}
        <Box sx={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={0.5}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: unread ? 700 : 500,
                fontSize: "0.8rem",
                color: unread ? "primary.main" : "text.primary",
                lineHeight: 1.3,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1,
              }}
            >
              {item.notTitulo}
            </Typography>
            {item.notFecReg && (
              <Box display="flex" alignItems="center" flexShrink={0}>
                <AccessTime
                  sx={{ fontSize: "0.65rem", color: "text.disabled", mr: 0.3 }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.65rem",
                    color: "text.disabled",
                    whiteSpace: "nowrap",
                  }}
                >
                  {timeAgo(item.notFecReg)}
                </Typography>
              </Box>
            )}
          </Box>
          {item.notNombrePersona && (
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                display: "block",
                fontSize: "0.72rem",
                lineHeight: 1.3,
              }}
            >
              {item.notNombrePersona}
              {item.notCargo && (
                <Typography
                  component="span"
                  variant="caption"
                  sx={{ color: "text.disabled", fontSize: "0.7rem", ml: 0.5 }}
                >
                  ({item.notCargo})
                </Typography>
              )}
            </Typography>
          )}
          {item.notContenido && (
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                fontSize: "0.7rem",
                lineHeight: 1.3,
                mt: 0.2,
              }}
            >
              {item.notContenido}
            </Typography>
          )}
          <Box mt={0.5}>
            <Chip
              label={item.notTipo}
              size="small"
              color={getTipoColor(item.notTipo)}
              variant={unread ? "filled" : "outlined"}
              sx={{
                height: 18,
                fontSize: "0.6rem",
                fontWeight: 600,
                textTransform: "capitalize",
                "& .MuiChip-label": { px: 0.8 },
              }}
            />
          </Box>
        </Box>
      </Box>
    );

    if (linkTo) {
      return (
        <NavLink
          key={item.notId}
          to={linkTo}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          {content}
        </NavLink>
      );
    }
    return <Box key={item.notId}>{content}</Box>;
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={openDrawerChat}
        onClose={onToogleDrawerChat}
        sx={{
          "& .MuiDrawer-paper": {
            borderTopLeftRadius: 16,
            borderBottomLeftRadius: 16,
          },
          zIndex: (theme) => theme.zIndex.drawer + 4,
        }}
        PaperProps={{
          sx: {
            backgroundColor: "background.paper",
            boxShadow: (theme) =>
              `-8px 0 32px ${alpha(theme.palette.common.black, 0.12)}`,
          },
        }}
      >
        <Box sx={{ width: 280 }} role="presentation">
          <Box sx={{ px: 2, py: 1.5 }}>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 700, color: "text.primary" }}
            >
              Chats
            </Typography>
          </Box>
          <Divider />
          <List sx={{ p: 1 }}>
            {grupos.map((grupo) => (
              <ListItemButton
                key={grupo.id}
                onClick={() => {
                  onToogleDrawerChat();
                  props.history.push(
                    `/Seguridad/chat/?chat_id=${grupo.chat_id}&name=${grupo.chat_name}`,
                  );
                }}
                sx={{
                  borderRadius: 2,
                  mb: 0.5,
                  "&:hover": {
                    backgroundColor: (theme) =>
                      alpha(theme.palette.primary.main, 0.08),
                  },
                }}
              >
                <ListItemAvatar>
                  <Badge
                    badgeContent={grupo.unread_messages}
                    color="primary"
                    sx={badgeSx}
                  >
                    <Avatar
                      src={grupo.unread_messages}
                      sx={{ width: 40, height: 40 }}
                    />
                  </Badge>
                </ListItemAvatar>
                <ListItemText
                  primary={grupo.chat_name}
                  primaryTypographyProps={{
                    fontSize: "0.85rem",
                    fontWeight: 500,
                  }}
                />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>

      <Box display="flex" alignItems="center" gap={0.3}>
        <Perfil open={openPerfil} setopen={setopenPerfil} />
        <Encuestas open={openEncuestas} setopen={setopenEncuestas} />

        {/* <Tooltip title="Chat" arrow>
          <IconButton
            onClick={onToogleDrawerChat}
            sx={{
              ...iconBtnSx,
              color: "success.main",
              "&:hover": {
                backgroundColor: (t) => alpha(t.palette.success.main, 0.08),
                color: "success.dark",
              },
            }}
          >
            <Badge
              badgeContent={totales}
              sx={{
                ...badgeSx,
                "& .MuiBadge-badge": {
                  ...badgeSx["& .MuiBadge-badge"],
                  backgroundColor: "success.main",
                  color: "success.contrastText",
                },
              }}
            >
              <Message sx={{ fontSize: "1.2rem" }} />
            </Badge>
          </IconButton>
        </Tooltip> */}

        <Tooltip title="Notificaciones" arrow>
          <IconButton
            aria-describedby={idNotificacion2}
            onClick={handleClickNotificacion2}
            sx={{
              ...iconBtnSx,
              color: totalNoLeidas > 0 ? "warning.main" : "text.secondary",
              "&:hover": {
                backgroundColor: (theme) =>
                  alpha(theme.palette.warning.main, 0.08),
                color: "warning.dark",
              },
            }}
          >
            <Badge
              badgeContent={totalNoLeidas}
              sx={{
                ...badgeSx,
                "& .MuiBadge-badge": {
                  ...badgeSx["& .MuiBadge-badge"],
                  backgroundColor:
                    totalNoLeidas > 0 ? "warning.main" : "transparent",
                  color:
                    totalNoLeidas > 0 ? "warning.contrastText" : "transparent",
                },
              }}
            >
              <Notifications sx={{ fontSize: "1.2rem" }} />
            </Badge>
          </IconButton>
        </Tooltip>
        <Popper
          sx={{ zIndex: 3500 }}
          id={idNotificacion2}
          open={openNotificacion2}
          anchorEl={anchorElNotificacion2}
          transition
          placement="bottom-end"
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={250}>
              <Paper
                elevation={0}
                sx={{
                  mt: 1,
                  borderRadius: 2.5,
                  minWidth: 380,
                  maxHeight: 460,
                  overflow: "hidden",
                  boxShadow: (theme) =>
                    `0 8px 32px ${alpha(
                      theme.palette.common.black,
                      0.12,
                    )}, 0 2px 8px ${alpha(theme.palette.common.black, 0.08)}`,
                  border: (theme) =>
                    `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                }}
              >
                <Box
                  sx={{
                    px: 2,
                    py: 1.2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: (theme) =>
                      `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                  }}
                >
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                    Notificaciones
                  </Typography>
                  {totalNoLeidas > 0 && (
                    <Chip
                      label={`${totalNoLeidas} sin leer`}
                      size="small"
                      color="warning"
                      variant="outlined"
                      sx={{ height: 22, fontSize: "0.7rem", fontWeight: 600 }}
                    />
                  )}
                </Box>
                <ClickAwayListener
                  onClickAway={() => setOpenNotificacion2(false)}
                >
                  <Box sx={{ maxHeight: 400, overflow: "auto" }}>
                    {todasNotificaciones.length === 0 && (
                      <Box sx={{ py: 4, textAlign: "center" }}>
                        <Notifications
                          sx={{
                            fontSize: "2rem",
                            color: "text.disabled",
                            mb: 1,
                          }}
                        />
                        <Typography variant="body2" color="text.secondary">
                          Sin notificaciones
                        </Typography>
                      </Box>
                    )}
                    {todasNotificaciones.map((item) =>
                      renderNotificacionItem(item, () => {
                        handleEditar(item);
                      }),
                    )}
                  </Box>
                </ClickAwayListener>
              </Paper>
            </Fade>
          )}
        </Popper>

        <Divider
          orientation="vertical"
          flexItem
          sx={{ mx: 0.5, height: 28, alignSelf: "center" }}
        />

        <Badge
          color="warning"
          badgeContent={
            (mensaje.tipo === "ACTUALIZACION" &&
              usuario.actualizacion_web === 1) ||
            mensaje.tipo === "MANTENIMIENTO"
              ? mensaje.detalle
              : null
          }
          sx={{ ":hover": { cursor: "pointer" } }}
          componentsProps={{
            badge: {
              style: { padding: "0.5rem 0.75rem", fontSize: "0.7rem" },
              onClick: async () => {
                if (usuario.actualizacion_web === 0) return;
                await clienteAxios.put("actualizaciones/actualizar_estado", {
                  tipo: "web",
                });
                window.location.reload(true);
              },
            },
          }}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Button
            color="inherit"
            onClick={handleClick}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.8,
              px: 1,
              py: 0.4,
              borderRadius: 2.5,
              textTransform: "none",
              color: "text.primary",
              "&:hover": {
                backgroundColor: (theme) =>
                  alpha(theme.palette.primary.main, 0.06),
              },
              transition: "background-color 0.2s",
            }}
          >
            <Avatar
              alt={usuario.nombres}
              src={usuario.foto}
              sx={{ width: 32, height: 32 }}
            />
            {!props.mobile && (
              <Typography
                sx={{
                  fontSize: "0.82rem",
                  fontWeight: 600,
                  maxWidth: 100,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {usuario.nombre}
              </Typography>
            )}
          </Button>
        </Badge>

        <DialogEmpresas
          open={openEmpresasDialog}
          setopen={setopenEmpresasDialog}
        />

        <Popper
          sx={{ zIndex: 3500 }}
          open={openMenu}
          anchorEl={anchorEl}
          transition
          placement="bottom-end"
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={250}>
              <Paper
                elevation={0}
                sx={{
                  mt: 1,
                  borderRadius: 2.5,
                  minWidth: 200,
                  overflow: "hidden",
                  boxShadow: (theme) =>
                    `0 8px 32px ${alpha(
                      theme.palette.common.black,
                      0.12,
                    )}, 0 2px 8px ${alpha(theme.palette.common.black, 0.08)}`,
                  border: (theme) =>
                    `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                }}
              >
                <ClickAwayListener onClickAway={() => setOpenMenu(false)}>
                  <MenuList sx={{ py: 0.5 }}>
                    {mensaje.tipo === "ACTUALIZACION" &&
                      usuario.actualizacion_web === 1 && (
                        <MenuItem
                          sx={{
                            mx: 0.5,
                            borderRadius: 1.5,
                            color: "warning.main",
                            fontWeight: 600,
                            fontSize: "0.85rem",
                          }}
                          onClick={async () => {
                            await clienteAxios.put(
                              "actualizaciones/actualizar_estado",
                              { tipo: "web" },
                            );
                            window.location.reload(true);
                          }}
                        >
                          Actualizar
                        </MenuItem>
                      )}
                    <MenuItem
                      sx={{
                        mx: 0.5,
                        borderRadius: 1.5,
                        fontSize: "0.85rem",
                        gap: 1.5,
                      }}
                      onClick={() => {
                        props.history.push("/Seguridad/Dashboard");
                        setOpenMenu(false);
                      }}
                    >
                      Inicio
                    </MenuItem>
                    <MenuItem
                      sx={{
                        mx: 0.5,
                        borderRadius: 1.5,
                        fontSize: "0.85rem",
                        gap: 1.5,
                      }}
                      onClick={() => {
                        setopenEncuestas(true);
                        setOpenMenu(false);
                      }}
                    >
                      Encuestas
                    </MenuItem>
                    {usuario.mis_empresas.length > 0 && (
                      <MenuItem
                        sx={{
                          mx: 0.5,
                          borderRadius: 1.5,
                          fontSize: "0.85rem",
                          gap: 1.5,
                        }}
                        onClick={() => {
                          setopenEmpresasDialog(true);
                          setOpenMenu(false);
                        }}
                      >
                        <Badge
                          badgeContent={usuario.mis_empresas.length}
                          color="secondary"
                          sx={badgeSx}
                        >
                          <Typography variant="inherit" color={"secondary"}>
                            Mis Empresas
                          </Typography>
                        </Badge>
                      </MenuItem>
                    )}
                    <Divider sx={{ my: 0.5 }} />
                    <MenuItem
                      sx={{
                        mx: 0.5,
                        borderRadius: 1.5,
                        fontSize: "0.85rem",
                        gap: 1.5,
                      }}
                      onClick={() => {
                        setopenPerfil(true);
                        setOpenMenu(false);
                      }}
                    >
                      <Person
                        sx={{ fontSize: "1.1rem", color: "text.secondary" }}
                      />{" "}
                      Mis Datos
                    </MenuItem>
                    <MenuItem
                      sx={{
                        mx: 0.5,
                        borderRadius: 1.5,
                        fontSize: "0.85rem",
                        gap: 1.5,
                        color: "error.main",
                        "&:hover": {
                          backgroundColor: (theme) =>
                            alpha(theme.palette.error.main, 0.06),
                        },
                      }}
                      onClick={() => {
                        cerrarSesion();
                        props.history.push("/login");
                      }}
                    >
                      <Logout sx={{ fontSize: "1.1rem" }} /> Cerrar Sesión
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Fade>
          )}
        </Popper>
      </Box>
    </>
  );
};

export default withRouter(NotificactionsButtons);
